import { render, staticRenderFns } from "./DashboardGrowthFilter.vue?vue&type=template&id=5133a167&scoped=true"
import script from "./DashboardGrowthFilter.vue?vue&type=script&lang=ts"
export * from "./DashboardGrowthFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5133a167",
  null
  
)

export default component.exports